define('common/ko/fn/arrays',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {

    //myObservableArray.any()
    ko.subscribable.fn.any = _.memoize(function() {
        var self = this;
        return ko.pureComputed(function() {
            return !_.isEmpty(self());
        });
    }, function() { return tools.objToHash([this]); } );

    /**
     * See docs for _.some
     */
    ko.subscribable.fn.some = function (predicate) {
        var self = this;
        return ko.pureComputed(function() {
            return _.some(self(), predicate);
        });
    };

    //myObservableArray.many()
    ko.subscribable.fn.many = _.memoize(function() {
        var self = this;
        return ko.pureComputed(function() {
            return _.size(self()) > 1;
        });
    }, function() { return tools.objToHash([this]); } );

    //myObservableArray.empty()
    ko.subscribable.fn.empty = _.memoize(function() {
        var self = this;
        return ko.pureComputed(function() {
            return _.isEmpty(self());
        });
    }, function() { return tools.objToHash([this]); } );

    /**
     * Use this to take the length of an observable array as an observable.
     *
     * @return {Observable Number}
     */
    ko.subscribable.fn.len = function () {
        var self = this;
        return ko.pureComputed(function() {
            return _.size(self());
        });
    };

    ko.subscribable.fn.first = function () {
        var self = this;
        return ko.pureComputed(function() {
            return _.first(self());
        });
    };

    /**
     * See _.take
     *
     * @param {Observable Number} n
     *
     * @return {ObservableArray mixed}
     */
    ko.subscribable.fn.take = function(n) {

        return ko.pureComputedArray(function() {
            return _.take(this(), ko.unwrap(n) || 0);
        }.bind(this));

    };

    /**
     * @deprecated Use more standard naming "take" instead
     * @todo dhowlett Remove this in March 2016
     */
    ko.subscribable.fn.firstNth = ko.subscribable.fn.take;

    /**
    * Use this to pad an array to the given size filled with value.
    *
    * @param {Number} size
    * @param {mixed} value
    *
    * @return {ObservableArray of mixed}
    */
    ko.subscribable.fn.pad = function (size, value) {
        var self = this;
        return ko.pureComputedArray(function() {
            var original = self();

            if (original.length >= size) {
                return original;
            }

            return _.map(_.range(size), function (i) {
                return original[i] || value;
            });
        });
    };

    ko.subscribable.fn.find = function(predicate) {

        var source = this;

        return ko.pureComputed(function() {
            return _.find(source(), predicate);
        });

    };

});

